import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ArrowRight } from 'lucide-react';
import { MagicLinkForm } from '@/routes/_layout/sign-in/-components/magic-link-form';
import { PasswordForm } from '@/routes/_layout/sign-in/-components/password-form';
import { GoogleButton } from '@/routes/_layout/-components/google-button';
import { ModeSwitcherButton } from '@/routes/_layout/sign-in/-components/mode-switcher-button';
import { TextSeparator } from '@/components/text-separator';
import { AppleButton } from '@/routes/_layout/-components/apple-button';
import { LinkedInButton } from '@/routes/_layout/-components/linkedin-button';
export const SignInCard = () => {
    const { t } = useTranslation(['common', 'glossary']);
    const [mode, setMode] = React.useState('password');
    return (<Card className="border-primary/20 shadow-sm backdrop-blur">
            <CardHeader>
                <CardTitle className="text-2xl">
                    {t('sign_in.title.prefix', { ns: 'glossary' })}&nbsp;
                    {t('sign_in.title.brand', { ns: 'glossary' })}
                </CardTitle>
                <CardDescription>
                    {mode === 'password'
            ? t('sign_in.subtitle', { ns: 'glossary' })
            : t('magic_link.subtitle', { ns: 'glossary' })}
                </CardDescription>
            </CardHeader>

            <CardContent className="space-y-5">
                {mode === 'password' && <PasswordForm />}

                {mode === 'magic' && <MagicLinkForm />}

                <TextSeparator>Or continue with</TextSeparator>

                <div className="space-y-2">
                    <AppleButton />
                    <GoogleButton />
                    <LinkedInButton />

                    <ModeSwitcherButton mode={mode} onChange={setMode}/>

                    <p className="text-xs text-muted-foreground text-center">
                        {t('dont_have_account')}&nbsp;
                        <Link to="/sign-up" className="text-primary hover:underline">
                            {t('create_campaign')}
                            <ArrowRight className="inline h-3.5 w-3.5 ml-1"/>
                        </Link>
                    </p>
                </div>
            </CardContent>
        </Card>);
};
